import React from "react";

import {
  ContainerTableStatus,
  TableStatus as TableStatusContainer,
} from "../../pages/panel/styles";

interface TableStatusProps {
  isLoading?: boolean;
  onClick: (date: any) => void;
  title: string;

  data: {
    name: string;
    value: string;
  }[];
}

export const TableFilter = ({
  title,
  onClick,
  data,
  isLoading = false,
}: TableStatusProps) => {
  return (
    <ContainerTableStatus>
      <header>
        <span>{title}</span>
      </header>
      <TableStatusContainer>
        <tbody>
          {data.map((status) => (
            <tr
              key={status.name}
              onClick={() => {
                if (!isLoading) {
                  onClick(status);
                }
              }}
            >
              <td>{status.name}</td>
            </tr>
          ))}

          {data.length <= 0 && (
            <tr>
              <td>-</td>
              <td>-</td>
            </tr>
          )}
        </tbody>
      </TableStatusContainer>
    </ContainerTableStatus>
  );
};
